import template from './AxFilterCheckbox.html';

function AxFilterCheckbox() {

  return {
    restrict: 'E',
    scope: {
      li18n: '=axI18n',
      filterItem: '=ngModel',
    },
    link: link,
    require: 'ngModel',
    template,
    controllerAs: 'vm',
    bindToController: true,
    controller: [controller]
  }

}

function controller() {

  var vm = this;

  vm.isValid = true;
  vm.invalidMessage = "";
  vm.allowNull = true;

  var conds = ax.AxDataLib.AxDataQueryCondition;

  vm.allowedOperators = [conds.Equal,
    conds.NotNull,
    conds.Null];

}

function link($scope, $element, $attrs, $ngModel) {

}

export { AxFilterCheckbox };
